import styled from "styled-components";

const AddressCard = styled.div`
  background-color: ${({ theme }) => theme.colors.baseWhite};
  padding: 26px 32px;
  box-shadow: ${({ theme }) => theme.shadows.card};
  border-radius: ${({ theme }) => theme.borderRadiusChecklistCard};

  display: grid;
  grid-auto-rows: auto;
  gap: 24px;

  form {
    display: grid;
    grid-auto-rows: auto;
    gap: 24px;
  }
`;

export default AddressCard;
